import React, { Component } from 'react';
import { connect } from 'react-redux';
import UpdateContainer from './update-container';
import ProgressBar from './progress-bar';

class Preferences extends Component {
	componentWillMount() {

	}



	render() {
		return (<section id="landing-page-component">
				<ProgressBar/>
				<UpdateContainer/>

			</section>
		);
	}

}

export default connect( null )( Preferences);